import { createApiStore, GenericStore } from "./genericStore";
import { FirmApp } from "../types/firmApp"; // Tip dosyanızın yolunu kontrol edin
import api from "../service/api";

// 1. Yeni Metodu Tanımlayan Interface
interface FirmAppStore extends GenericStore<FirmApp> {
  sendUpdateNotification: (firmId: number, appIdentifier: string) => Promise<any>;
}

// 2. Store Oluşturma
export const useFirmAppStore = createApiStore<FirmApp>("/firm-apps") as unknown as () => FirmAppStore;

// 3. Extra Aksiyon Ekleme
const useFirmAppStoreBase = useFirmAppStore as any;

useFirmAppStoreBase.setState((state: any) => ({
  ...state,
  sendUpdateNotification: async (firmId: number, appIdentifier: string) => {
    try {
      useFirmAppStoreBase.setState({ loading: true, error: null });
      
      const res = await api.post(`/firm-apps/send-update-notification`, {
        firmId,
        appIdentifier
      });
      
      useFirmAppStoreBase.setState({ loading: false });
      return res.data;
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || "Güncelleme bildirimi gönderilirken hata oluştu";
      useFirmAppStoreBase.setState({ 
        error: { message: errorMessage, details: err.response?.data?.details || null }, 
        loading: false 
      });
      throw err;
    }
  }
}));